import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  container: {
    position: 'relative',
    width: '100%',
    height: 'auto',
    pb: ['16px', '16px', '16px', '16px', '24px', '24px', 0]
  },
  buttonFilters: (active: boolean) => ({
    position: 'absolute',
    right: ['11px', '11px', '11px', '11px', '11px', '11px', '27px'],
    top: 0,
    transform: 'translateY(-48px)',
    zIndex: theme.zIndex.documentHigh,
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: active ? theme.rawColors.lightGrey300 : 'transparent'
  }),
  filtersContainer: (active: boolean) => ({
    width: '100%',
    height: active ? 'auto' : 0,
    opacity: active ? 1 : 0,
    ...reusables.mainTransition('height, opacity'),
    overflow: 'hidden',
    '.headings.heading__four.mobile': {
      display: 'flex',
      flexFlow: 'row no-wrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
      button: {
        ml: '8px'
      }
    }
  }),
  filtersWrapper: {
    display: 'flex',
    flexFlow: 'row wrap',
    width: '100%',
    height: 'auto',
    '&:first-of-type': {
      mb: ['17px', '17px', '17px', '17px', '17px', '17px', '32px']
    },
    '.swiper': {
      position: 'relative',
      width: '100%',
      height: ['62px', '62px', '62px', '62px', '62px', '62px', 'auto']
    },
    '.swiper-wrapper': {
      display: 'flex',
      flexFlow: 'row wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      width: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', '100%'],
      height: ['47px', '47px', '47px', '47px', '47px', '47px', 'auto']
    },
    '.swiper-slide': {
      display: 'flex',
      flexFlow: ['row no-wrap', 'row no-wrap', 'row no-wrap', 'row no-wrap', 'row no-wrap', 'row no-wrap', 'row wrap'],
      width: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', '100%'],
      height: 'auto'
    },
    button: {
      display: 'flex',
      flexFlow: 'row no-wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '4px 12px 12px 4px',
      minHeight: '47px',
      p: ['8px 24px'],
      '.icon': {
        marginRight: '12px'
      },
      span: {
        display: 'flex',
        flexFlow: 'row no-wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }
  },
  activeButton: (active: boolean) => ({
    backgroundColor: active ? `${theme.rawColors.lightGrey300} !important` : 'transparent',
    border: active ? `1px solid ${theme.rawColors.lightGrey300}` : null
  })
};